export class SideNavTextDataIT {
    static readonly htmlLabel = {
        appName: 'PREP',
        ariaMainNav: 'Menu di navigazione principale',
        ariaGoDashboard: 'Vai alla pagina della dashboard',
        ariaExpandMenu: 'Espandi il menu laterale',
        ariaCollapseMenu: 'Comprimi il menu laterale',

    };
    static readonly snackbarLabel = {
        signedOut: 'Disconnesso.',
        welcomeMyProfile: 'Benvenuto nel mio profilo!',
        welcomeDashboard: 'Benvenuto nella dashboard!',
    };
    static readonly tooltipLabel = {
        userProfileText: 'Profilo',
        userLogoutText: 'Disconnettersi',

    }
    static readonly menuLabel = {

        menuDashboard: 'Dashboard',
        menuUploadFile: 'Carica File',
        menuExport: 'Esportazioni',
        menuReport: 'Report',
        menuHeaderAdminTool: 'STRUMENTO DI AMMINISTRAZIONE',
        menuFileUploadUsage: 'Utilizzo del Caricamento File',
        menuAPIUsage: 'Utilizzo API',
        menuAccountConfig: 'Configurazione Account',
        menuTemplateConfig: 'Configurazione Modelli',
        menuExternalUsage: 'Utilizzo Esterno',
        menuHeaderCEAdmin: 'AMMINISTRAZIONE CE',
        menuHeaderCanvasIntegration: 'INTEGRAZIONE CANVAS',
        menuCanvasLMSFiles: 'File di Canvas LMS',
        menuHeaderCivicPlusIntegration: 'INTEGRAZIONE CON CIVICPLUS',
        menuCivicPlusFiles: 'File di CivicPlus',
        menuHeaderCivicPlusV2Integration: 'INTEGRAZIONE CON CIVICPLUS',
        menuCivicPlusV2Files: 'File di CivicPlus',
        MenuHeaderRemediationServices: 'SERVIZI DI REMEDIAZIONE',
        MenuHeaderBlackboardIntegration: 'INTEGRAZIONE CON BLACKBOARD',
        menuBlackboardFiles: 'File di Blackboard',
        MenuHeaderWordpressIntegration: 'INTEGRAZIONE CON WORDPRESS',
        menuWordpressFiles: 'File di WordPress',
        menuOrder: 'Ordini',
        menuTransactions: 'Transazioni',
        MenuHeaderD2lIntegration: 'INTEGRAZIONE D2L',
        menuD2lLMSFiles: 'File di D2L LMS',
        MenuHeaderD2lApiIntegration: 'INTEGRAZIONE D2L',
        menuD2lApiFiles: 'File di D2L',
        MenuHeaderRSPAdministration: 'AMMINISTRAZIONE DEL SERVIZIO RSP',
        menuCEOrders: 'Ordini CE',
        menuUsageDashboard: 'Dashboard di Utilizzo',
        menuUsers: 'Utenti',
        menuCEUserNotificationUser: 'Notifica utente CE',
        menuExternalContact: 'Contatto esterno'

    };
}